// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2JYXr","dragIcon":"Choice_dragIcon__embkD","left":"Choice_left__3JbYi","input":"Choice_input__kf2kk"};